"use client";
import { useRouter } from "@commerce-frontend/i18n/navigation";
import { Icon } from "@commerce-frontend/ui/base/Icon/Icon";
import { Skeleton } from "@commerce-frontend/ui/base/Skeleton/Skeleton";
import {
	ListItem,
	ListItemContent,
	ListItemDescription,
	ListItemIcon,
	ListItemLabel,
	ListItemOverline,
} from "@commerce-frontend/ui/components/ListItem/ListItem";
import { range } from "@labdigital/toolkit";
import { useTranslations } from "next-intl";
import { useTransition } from "react";
import { useHits, useInstantSearch } from "react-instantsearch";
import type { AlgoliaStore } from "~/app/[locale]/(regular-layout)/stores/types";
import { useMenu } from "../../../MenuContext";

export const SearchStores = () => {
	const { items } = useHits<AlgoliaStore>();
	const t = useTranslations("SearchStores");
	const { results, status } = useInstantSearch();
	const { setSearchOpen } = useMenu();
	const [_, startTransition] = useTransition();
	const router = useRouter();

	if (!items.length && results?.query && status === "idle") {
		return;
	}

	return (
		<div className="w-full shrink-0 lg:w-[300px]">
			<div className="mb-xs flex h-11 items-center py-sm text-gray-700">{t("title")}</div>

			<div className="flex flex-col gap-xs">
				{(!items.length && !results?.query) || status === "loading"
					? range({ start: 0, end: 4 }).map((item) => (
							<div key={item}>
								<Skeleton type="rectangle" className="min-h-16 w-full rounded-xs" />
							</div>
						))
					: items.map((item) => (
							<ListItem
								href={{
									pathname: "/stores/[slug]",
									params: {
										slug: item.slug,
									},
								}}
								onClick={() => {
									startTransition(() => {
										router.push({
											pathname: "/stores/[slug]",
											params: {
												slug: item.slug,
											},
										});
										setSearchOpen(false);
									});
								}}
								key={item.objectID}
							>
								<ListItemIcon>
									<Icon icon="marker-pin-01" />
								</ListItemIcon>
								<ListItemContent>
									{item?.storeCode === "X" && <ListItemOverline>XL</ListItemOverline>}
									<ListItemLabel>{item?.name}</ListItemLabel>
									<ListItemDescription>
										{item?.address?.addressLine} {item?.address?.streetNumber}
									</ListItemDescription>
								</ListItemContent>
							</ListItem>
						))}
			</div>
		</div>
	);
};
